export default "__VITE_ASSET__G0W2IzCY__"